/* eslint-disable no-unused-expressions */
import { howlMapper } from 'config/constants/audio'
import { InhouseGameDetails } from 'config/types/game'
import React, { useEffect, useState } from 'react'
import { StyledInhouseGameContainer } from '../components/styled'
import { GameInHouseConfig } from '../config/types'
import { useInhouseSession } from '../Plinko/hooks'
import WheelBetSettings from './components/BetBoard'
import GameBoard from './components/GameBoard'
import { WHEEL_RISK_DEFAULT, WHEEL_SEGMENTS_DEFAULT } from './config'
import { WheelSegments } from './config/types'

const WheelGame: React.FC<GameInHouseConfig & { game: InhouseGameDetails }> = ({ volumeEnable, game, ...config }) => {
  const [isLocked, setIsLocked] = useState(false)

  const [segments, setSegments] = useState<WheelSegments>(WHEEL_SEGMENTS_DEFAULT)
  const [risk, setRisk] = useState(WHEEL_RISK_DEFAULT)

  const { gameSettings } = useInhouseSession({
    game,
  })

  useEffect(() => {
    // Init audio
    howlMapper.WheelPlaying
    howlMapper.WheelWin
  }, [])

  return (
    <StyledInhouseGameContainer>
      <WheelBetSettings
        setIsLocked={setIsLocked}
        volumeEnable={volumeEnable}
        segments={segments}
        setSegments={setSegments}
        risk={risk}
        setRisk={setRisk}
        isLocked={isLocked}
        game={game}
        gameSettings={gameSettings}
        {...config}
        width="100%"
        mt={['16px', '', '', '', '0']}
      />

      <GameBoard volumeEnable={volumeEnable} game={game} segments={segments} risk={risk} />
    </StyledInhouseGameContainer>
  )
}

const WheelGameMemorized = React.memo(WheelGame)

export default WheelGameMemorized
